module.exports = {
  footerText: 'Copyright © 2021 Caregility Corporation',
};
